import React from 'react';
import DriveGallery from '../../components/DriveGallery';

const VodoLodniSoutez = () => (
  <DriveGallery
    galleryId="vodo-lodni-soutez"
    title="Vodo-lodní soutěž"
  />
);

export default VodoLodniSoutez;
